// Works for above IE9
 
window.performance = window.performance || {
  offset: Date.now(),
  now: function now() {
    return Date.now() - this.offset;
  },
};
